module.exports = __webpack_public_path__ + "img/close.2b70a3c0.png";